import { useEffect, useState } from "react";
import api from "../lib/api";
import { Loader } from "../components/common";
import MessageThread from "../components/MessageThread";

export default function Messages() {
  const [conv, setConv] = useState(undefined);

  useEffect(() => {
    api.get("/conversations").then(({ data }) => setConv(data[0] || null)).catch(() => setConv(null));
  }, []);

  if (conv === undefined) return <Loader />;
  if (!conv) return <div className="p-5"><h1 className="font-heading text-4xl">Messages</h1><p className="text-secondary mt-4">No conversation yet. Your coach will reach out soon.</p></div>;

  return (
    <div className="h-[calc(100vh-72px)] flex flex-col">
      <MessageThread conversationId={conv.id} headerName={conv.participant?.name} headerPic={conv.participant?.picture} />
    </div>
  );
}
